(() => {
  function update(count) {
    const quantity = Number(count);
    if (!Number.isFinite(quantity)) return;
    document.querySelectorAll('[data-cm-progress]').forEach(progress => {
      progress.dataset.count = quantity;
      progress.setAttribute('aria-label', quantity + ' prodotti nel carrello. Sconti: 2 prodotti 10%, 3 prodotti 15%, 4 prodotti 20%, 5 o più prodotti 25%.');
      const fill = progress.querySelector('[data-cm-fill]');
      if (fill) fill.style.width = Math.min(100, Math.max(0, quantity >= 5 ? 100 : (quantity - 2) * 25 + 12.5)) + '%';
      progress.querySelectorAll('[data-cm-tier]').forEach(tier => {
        const target = Number(tier.dataset.cmTier);
        tier.classList.toggle('is-reached', quantity >= target);
        tier.classList.toggle('is-next', quantity + 1 === target);
      });
    });
  }
  function init() {
    document.querySelectorAll('[data-cm-progress]').forEach(progress => update(progress.dataset.count));
  }
  document.addEventListener('theme:cart:change', event => update(event.detail.cartCount));
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();